var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-recommended-rents"},[_c('button',{staticClass:"btn btn-primary mr-3 px-4 py-0",on:{"click":_vm.downloadRecommendedRents}},[_vm._v(_vm._s(_vm.$t('property_page.download')))])])}
var staticRenderFns = []

export { render, staticRenderFns }